@if (form != null) {
    <sm-toolbar>
        <p-checkbox class="ml-3" label="Versteckte Felder anzeigen" [binary]=true [(ngModel)]="displayHiddenFields"></p-checkbox>
        <p-checkbox class="ml-3" label="Feldinformationen in Tooltip anzeigen" [binary]=true [(ngModel)]="infoInTooltip"></p-checkbox>
        <p-checkbox class="ml-3" label="Interne Namen anzeigen" [binary]=true [(ngModel)]="displayInternalNames"></p-checkbox>
    </sm-toolbar>
    <sm-form #clientFormRef [form]="form" [style.position]="'relative'">
    </sm-form> 
}